module.exports = __webpack_public_path__ + "static/img/sand_8_max.5e8f5eb0.png";